import _GroupSettings from "./group-settings.component.js";
import _Settings from "./settings.component.js";
import _UserSettings from "./user-settings.component.js";

export const GroupSettings = _GroupSettings;
export const Settings = _Settings;
export const UserSettings = _UserSettings;
